import { localStg } from '@/utils/storage';
import type { VersionType } from './index';

// Get version
export function getVersion(): VersionType {
  return localStg.get('version') || 'BASE';
}
